export default __webpack_public_path__ + "static/media/fact_sheet36.23eac839.png";